// file to keep constant values which can be used throughout the app

const platformIds = {
  'GOOGLE': 1,
  'FACEBOOK': 2,
  'INSTAGRAM': 4,
};


export {
  platformIds,
};
